class ExpandableContent {
	 constructor (elem) {
		this.elem = elem[0]
		this.componentSelector = '.expandable-content__heading';

		this.elem.querySelector(this.componentSelector).addEventListener("click", (e) => {
			e.preventDefault();
			this.eventClick(this.elem)
		});
		document.body.onkeydown = (e) => {
			if (e.key == " " ||
				e.code == "Space" || e.code == "Enter"   
			) {
				if(document.activeElement.closest(this.componentSelector) !== null){
					e.preventDefault();
					this.eventClick(document.activeElement.closest(this.componentSelector));
				}
			}
		}

		if (location.hash.split("#")[1] == this.elem.id){
			this.eventClick(this.elem)
		}
  	}	

	eventClick (elem) {
		const newUrl = location.href.split("#")[0] + "#" + elem.id;
		history.replaceState(null, "",newUrl);
		elem.classList.toggle('is-open');
	}
}

export default ExpandableContent;